"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Outlined = _interopRequireDefault(require("./Outlined"));

var _Standard = _interopRequireDefault(require("./Standard"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

function Input(props, ref) {
  var variant = props.variant,
      other = (0, _objectWithoutProperties2["default"])(props, ["variant"]);

  if (variant === 'standard') {
    return (0, _core.jsx)(_Standard["default"], (0, _extends2["default"])({
      ref: ref
    }, other));
  }

  return (0, _core.jsx)(_Outlined["default"], (0, _extends2["default"])({
    ref: ref
  }, other));
}

var BaseInput = (0, _react.forwardRef)(Input);
exports.BaseInput = BaseInput;

var _default = (0, _react.forwardRef)(Input);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Input, "Input", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/index.tsx");
  reactHotLoader.register(BaseInput, "BaseInput", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Input/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();